// כל המחרוזות של רנדרר הבלוקים — קובץ אחד (11 §6: בלי מסגרת i18n).
export const S = {
  table: 'טבלה',
  chart: 'גרף',
  noRows: 'אין שורות',
  noDesc: 'ללא תיאור',
  noDescTitle: 'קוד בלי תיאור תואם',
  showMore: (n: number) => `הצג עוד (${n.toLocaleString('he-IL')} נוספות)`,
  moreRows: (n: number) => (n === 1 ? 'עוד שורה אחת' : `עוד ${n.toLocaleString('he-IL')} שורות`),
  truncated: (shown: number, total?: number) =>
    total ? `מוצגות ${shown.toLocaleString('he-IL')} שורות מתוך ${total.toLocaleString('he-IL')}.` : `מוצגות ${shown.toLocaleString('he-IL')} שורות בלבד (נחתך).`,
  exportXlsx: 'ייצוא Excel',
  exportPng: 'ייצוא תמונה',
  viewTable: 'טבלה',
  viewChart: 'גרף',
  unknownBlock: (t: string) => `בלוק שאינו נתמך בתצוגה: ${t}`,
  download: 'הורדה',
  downloadFailed: 'ההורדה נכשלה',
  htmlTitle: 'תוכן מבודד',
  appTitle: 'תצוגה אינטראקטיבית',
  appError: 'שגיאה בקוד התצוגה',
  appConsent: 'הפעולה ממתינה לאישור',
  appConsentOpen: 'לאישור',
  appNoCall: 'הפעולה זמינה רק במסך של ריצה',
  // app@2: שורת המארח לפעולות שנפתחו מהמטמון — אותן מחרוזות כמו בדוח (report@2)
  appComputedAgo: (ago: string) => `חושב ${ago}`,
  appRecomputing: 'מחשב מחדש…',
  appTooMany: 'יותר מדי פעולות פתוחות. נסה שוב בעוד רגע',
  appFileFailed: 'הקובץ לא נמצא או שאין לך גישה אליו',
  appFileNone: 'הורדת קבצים זמינה רק במסך של ריצה',
  appRunLoading: 'טוען את האפליקציה…',
  appRunMissing: 'האפליקציה של הריצה לא נמצאה, או שאין לך גישה אליה',
  runAs: (name: string) => `רץ בשם ${name}`,
  expand: 'הגדל',
  expandBack: 'חזור',
  expanded: 'תצוגה מוגדלת',
  notice: { info: 'מידע', degraded: 'נתונים חלקיים', error: 'שגיאה', unsupported: 'לא נתמך' } as Record<string, string>,
} as const;
